"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Consumer = exports.Provider = void 0;

var React = _interopRequireWildcard(require("react"));

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var _a;

var Provider = (_a = React.createContext(new _universalCookie.default()), _a.Provider),
    Consumer = _a.Consumer;
exports.Consumer = Consumer;
exports.Provider = Provider;


//////////////////
// WEBPACK FOOTER
// ./~/react-cookie/cjs/CookiesContext.js
// module id = 202
// module chunks = 114276838955818